import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import Select from 'react-select'
import { toast } from 'react-toastify'

import {
  useAssignPolicyToUserMutation,
  useGetCategoryAccessPoliciesQuery,
} from '../../../../api/services/categoryAccessPolicyApi'
import { clientStyles } from '../../../../data/createStampSelectStyles'
import NewModal from '../../../root/modals/NewModal'

const AssignPolicyModal = ({ open, onClose, user }) => {
  const { t } = useTranslation()
  const company = useSelector((state) => state.company.company)
  const [selectedPolicy, setSelectedPolicy] = useState(null)

  const { data: policies } = useGetCategoryAccessPoliciesQuery(company?.id, {
    skip: !company?.id,
  })
  const [assignPolicy] = useAssignPolicyToUserMutation()

  const policyOptions = [
    { value: null, label: t('no_policy_assigned') },
    ...(policies?.map((policy) => ({
      value: policy.id,
      label: policy.name,
    })) || []),
  ]

  useEffect(() => {
    if (!user) return

    if (user.policyId && policies?.length) {
      const current = policies.find((policy) => policy.id === user.policyId)
      setSelectedPolicy(
        current ? { value: current.id, label: current.name } : { value: null, label: t('no_policy_assigned') },
      )
      return
    }

    setSelectedPolicy({ value: null, label: t('no_policy_assigned') })
  }, [user, policies, t])

  const handleSubmit = async () => {
    try {
      const response = await assignPolicy({
        companyId: company?.id,
        userId: user.id,
        policyId: selectedPolicy?.value ?? null,
      }).unwrap()
      toast.success(response.message)
      onClose()
    } catch (error) {
      toast.error(error.data?.message || t('err_occ'))
    }
  }

  return (
    <NewModal
      showModal={open}
      closeModal={onClose}
      setShowModal={onClose}
      btns
      titleClose={t('close')}
      titleSubmit={t('submit')}
      title={t('assign_policy') + ' - ' + user?.username}
      onClickClose={onClose}
      onClickSubmit={handleSubmit}
    >
      <div className="w-full flex flex-col gap-4 min-h-40">
        <Select
          styles={clientStyles}
          options={policyOptions}
          value={selectedPolicy}
          onChange={setSelectedPolicy}
          placeholder={t('select_policy')}
        />
      </div>
    </NewModal>
  )
}

export default AssignPolicyModal
